import './NavBar.css';

import { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';

import logo from '../assets/img/logo.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import mobileMenu from '../assets/img/mobileMenu.svg';

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);
    const sectionIds = ['home', 'aboutMe', 'projects', 'contact'];

    useEffect(() => {
        const onScroll = () => {
            let section = null;
            sectionIds.forEach(id => {
                const el = document.getElementById(id);
                if (el) {
                    if (window.scrollY >= (el.offsetTop - window.innerHeight / 2) && window.scrollY < (el.offsetTop + el.offsetHeight)) {
                        section = id;
                    }
                }
            });

            if (window.scrollY > 50 || window.location.pathname.includes("proyecto")){
                setScrolled(true);
            } else {
                setScrolled(false);
            }

            removeOldActives(section);
            onUpdateActivelink(section);
            if (section && section !== 'null') {
                window.history.replaceState(null, null, `#${section}`);
            } else {
                window.history.replaceState(null, null, window.location.pathname);
            }
        }
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onUpdateActivelink = (value) => {
        setActiveLink(value);
    }

    const removeOldActives = (value) => {
        const navLinks = document.querySelectorAll('[nav-id]');
        navLinks.forEach(link => {
            if (link.attributes[0].nodeValue !== (value)) {
                link.classList.remove('active');
            }
        });
    }

    return (
        <Navbar expand="lg" collapseOnSelect className={scrolled ? "scrolled" : ""}>
            <Container fluid>
                <Navbar.Brand href="/#home">
                    <img src={logo} alt="Logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-Navbar-nav">
                    <span className="navbar-toggle-icon"><img src={mobileMenu} alt="Menu" style={{ width: '20px', height: '20px' }} /></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-Navbar-nav">
                    <Nav className="mx-auto">
                        <Nav.Link nav-id="home" href="/#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} >Inicio</Nav.Link>
                        <Nav.Link nav-id="aboutMe" href="/#aboutMe" className={activeLink === 'aboutMe' ? 'active navbar-link' : 'navbar-link'} >Sobre mí</Nav.Link>
                        <Nav.Link nav-id="projects" href="/#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} >Proyectos</Nav.Link>
                        <Nav.Link nav-id="contact" href="/#contact" className={activeLink === 'contact' ? 'active navbar-link' : 'navbar-link'} >Contacto</Nav.Link>
                    </Nav>
                    <span className="navbar-text">
                        <div className="social-icon">
                            <a href="https://www.linkedin.com/in/j-penarrubia" target="_blank" rel="noopener noreferrer">
                                <img src={navIcon1} alt="LinkedIn" />
                            </a>
                            <a href="https://github.com/j-penarrubia" target="_blank" rel="noopener noreferrer">
                                <img src={navIcon2} alt="" />
                            </a>
                        </div>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}